
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(50192|68200)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
